import * as Toastr from "toastr";

declare global {
    // tslint:disable-next-line: interface-name
    interface Window {
        toastr_notifications: Toastr;
    }
}

export function LoadPage() {
    window.toastr_notifications = Toastr;
}


